import React, {useMemo} from 'react';
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import LifeRisk from "../../citizen/utils/life-risk.js";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {fluidPx} from "../../../../../utils/responsive-graph.js";

const LIFE_RISK_COLORS = {
    LOW: '#50A6F9',
    MEDIUM: '#8DBFE3',
    HIGH: '#1F4F87'
};


const SosHomeLifeRisk = ({data}) => {
    const vw = useGraphViewportWidth();

    const option = useMemo(() => {
        if (!data?.citizensByLifeRisk) return {};

        const LegendFs = fluidPx(13, 24, vw);
        const labelFs = fluidPx(11, 24, vw);

        return {
            tooltip: {trigger: 'item', extraCssText: 'max-width: 320px; white-space: normal;'},
            title: {
                text: 'Grau de risco:',
                bottom: '32%',
                left: 'center',
                textStyle: {fontSize: LegendFs, color: '#676a6c', fontWeight: 'bold'}
            },
            legend: {
                orient: 'vertical',
                bottom: "5%",
                left: 'center',
                icon: 'circle',
                itemGap: 12,
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {fontSize: LegendFs, color: '#676a6c'}
            },
            series: [
                {
                    name: "Grau de risco",
                    type: 'pie',
                    radius: ['45%', '75%'],
                    center: ['50%', '50%'],
                    startAngle: 180,
                    endAngle: 360,
                    padAngle: 4,
                    itemStyle: {borderRadius: 8},
                    label: {
                        show: true,
                        fontSize: labelFs,
                        color: '#063A6C',
                        formatter: ({value}) => value
                    },
                    labelLine: {length: 6, length2: 6},
                    data: Object.keys(data.citizensByLifeRisk).map(key => ({
                        value: data.citizensByLifeRisk[key],
                        name: LifeRisk.toView(key),
                        itemStyle: {color: LIFE_RISK_COLORS[key]}
                    }))
                }
            ]
        };
    }, [data?.citizensByLifeRisk, vw])

    return (
        <SentryEchart
            option={option}
            title={"Distribuição dos protegidos"}
            titleClass={"text-[#676a6c]!"}
        />
    );
};

export default SosHomeLifeRisk;